import {
  AgBarSeriesTooltipRendererParams,
  AgLineSeriesTooltipRendererParams,
  AgAreaSeriesTooltipRendererParams,
  AgScatterSeriesTooltipRendererParams,
  AgBarSeriesOptions,
  AgLineSeriesOptions,
  AgAreaSeriesOptions,
  AgScatterSeriesOptions,
} from 'ag-charts-enterprise';

export const ChartType = {
  BAR: 'bar',
  LINE: 'line',
  AREA: 'area',
  SCATTER: 'scatter',
} as const;

export type ChartTypeOption = (typeof ChartType)[keyof typeof ChartType];

export const GraphChartType = {
  ...ChartType,
  CUSTOM: 'custom',
} as const;

export type GraphChartTypeOption =
  (typeof GraphChartType)[keyof typeof GraphChartType];

export enum ChartDirection {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

export type RingSerieRendererParams =
  | AgBarSeriesTooltipRendererParams
  | AgLineSeriesTooltipRendererParams
  | AgAreaSeriesTooltipRendererParams
  | AgScatterSeriesTooltipRendererParams;

export type RingSerieOptions =
  | AgBarSeriesOptions
  | AgLineSeriesOptions
  | AgAreaSeriesOptions
  | AgScatterSeriesOptions;
